import React from "react"
import Artifact from "../artifact";
import Video from "../../video/Video";
import Figure from "../figure";

const Nawasi = () => (
  <Artifact>
    <Figure
      creditPosition="top-left"
      caption="Secret prison in Tripoli, Libya, where The Outlaw Ocean Project’s reporters were kept captive"
      captionSize="small"
      captionAlign="left"
    >
      <Video
        src="https://cdn.theoutlawocean.com/al-mabani/clips__secret-prison.mp4"
        muted="muted"
        autoplay="autoplay"
        loop="loop"
      />
    </Figure>
  </Artifact>
);

export default Nawasi;